<!--suppress ALL -->
<template>
	<v-select
		v-model="model"
		:items="options"
		:loading="loading"
		:small-chips="multiple"
		:multiple="multiple"
		label="בחר ארגונים"
		item-text="name"
		item-value="id"
	/>
</template>

<script>
import OrganizationModule from "src/store/modules/Organization.module";

export default {
	name: "OrganizationsSelect",
	components: {},
	props: { value: { default: null }, multiple: Boolean },
	data () {
		return {
			loading: false,
		};
	},
	computed: {
		options () {
			return this.$store.state.OrganizationModule.organizations;
		},
		model: {
			get () {
				return this.value;
			},
			set (val) {
				return this.$emit("input", val);
			},
		},
	},
	// mixins: [new SelectMixin(OrganizationModule, "organizations")],
	async created () {
		this.loading = true;
		await this.$store.dispatch(OrganizationModule.types.FETCH);
		this.loading = false;
	},
};
</script>
